<template>

    <li class="c-form_video">
        <div
            class="c-form_video__cover"
            :style="getVideoThumb"
            @click="$emit('delete')">
            <button type="button" class="c-form_video__delete" v-if="canDelete">
                <span class="c-form_video__delete-i"></span>
                <span class="c-form_video__delete-title">Usuń ten film</span>
            </button>
        </div>
        <span
            class="c-form_video__caption"
            :class="{ 'c-form_video__caption--shown' : title !== '' }">{{ title }}</span>
    </li>

</template>


<script>

import getVideoTitle from 'get-youtube-title'

export default {

    name: 'FormVideo',

    props: {
        canDelete: Boolean,
        url: String
    },

    data() {
        return {
            title: '',
        }
    },

    computed: {
        parsedVideoId() {
            var match = this.url.match(/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/)
            return (match && match[1].length) === 11 ? match[1] : false
        },
        getVideoThumb() {
            return {
                backgroundImage: 'url(\'https://img.youtube.com/vi/' + this.parsedVideoId + '/hqdefault.jpg\')'
            }
        }
    },

    mounted() {
        this.$nextTick(() => {
            getVideoTitle(this.parsedVideoId, (err, title) => {
                this.title = title
            })
        })

    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-form_video {
    position: relative;
    width: 33.3%;
    padding: 5px;
    opacity: 1;
    transition: opacity .2s ease-in-out;

    &__cover {
        position: relative;
        padding-top: 60%;
        width: 100%;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        border-radius: 4px;
        overflow: hidden;
    }
    &__delete {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        border: 0;
        background-color: rgba($c-primary, 0.8);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity .2s ease-in-out;
        cursor: pointer;

        &-i {
            width: 35px;
            height: 35px;
            background-image: url('#{$icons}/delete2.svg');
            background-position: center;
            background-size: 100%;
            background-repeat: no-repeat;
            margin-bottom: 10px;
            pointer-events: none;
        }
        &-title {
            text-align: center;
            color: $c-white;
            font-size: 0.9rem;
            font-weight: bold;
            pointer-events: none;
        }
    }
    &__caption {
        display: block;
        color: $c-third;
        font-weight: 600;
        margin: 0.5rem 0;
        line-height: 1rem;
        max-height: 1rem;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        opacity: 0;
        transition: opacity .5s ease-in-out;

        &--shown {
            opacity: 1;
        }
    }
    &:hover &__delete {
        opacity: 1;
    }
}

</style>
